// Модуль отвечающий за отправку конверсии с формы опроса удовлетворенности пользователей
// в листингах товаров и компаний, данная форма не привязана к конкретному товару,
// поэтому пришлось отказаться от использования модуля app.modules.conversionEventLog,
// который отправляет конверсию с привязкой к конкретному товару

import {fetchData} from '@apress/apress-frontend-utils/utils/fetch-data/fetch-data.js';
import {registerWithSID} from 'src/assets/js/utils/register_with_sid.js';

app.modules.satisfactionSurveyForm = (function (self) {
  const _fullFormShowButton = document.querySelector('.js-show-full-form');
  const _satisfactionForm = document.forms.satisfaction;

  function _setSubmitButtonState() {
    const {rating, comment, submit} = _satisfactionForm.elements;
    if (Number(rating.value) || comment.value.length) {
      submit.disabled = false;
      return;
    }

    submit.disabled = true;
  }

  function _toggleRatingButton(button) {
    button.classList.toggle('satisfaction-survey-form__button_selected');
    _satisfactionForm.elements.rating.value = button.classList.contains(
      'satisfaction-survey-form__button_selected'
    )
      ? button.dataset.value
      : '';
    _setSubmitButtonState();
  }

  function _changeRatingButtonState(button) {
    const selectedButton = _satisfactionForm.querySelector(
      '.satisfaction-survey-form__button_selected'
    );
    if (selectedButton && selectedButton === button) {
      _toggleRatingButton(selectedButton);
      return;
    }

    if (selectedButton) {
      _toggleRatingButton(selectedButton);
    }

    _toggleRatingButton(button);
  }

  function _toggleFullForm() {
    document
      .querySelector('.satisfaction-survey-form__hidden-block')
      .classList.toggle('satisfaction-survey-form__hidden-block_invisible');
    _fullFormShowButton.classList.toggle(
      'satisfaction-survey-form__button_hidden'
    );
  }

  function _getFormData() {
    const formData = {
      rating: '',
      comment: '',
      contact: '',
    };

    for (let field in formData) {
      formData[field] =
        _satisfactionForm.elements[field] &&
        _satisfactionForm.elements[field].value;
    }

    return formData;
  }

  function _resetForm() {
    _satisfactionForm.reset();

    const selectedButton = _satisfactionForm.querySelector(
      '.satisfaction-survey-form__button_selected'
    );
    selectedButton &&
      selectedButton.classList.remove(
        'satisfaction-survey-form__button_selected'
      );
  }

  function _sendConversionData(payload) {
    return fetch(app.config.loggingData.requestUrl, {
      method: 'POST',
      body: _getRequestBody(payload),
    });
  }

  function _getRequestBody(payload) {
    const body = {
      conversion_type: 'survey_in_listing',
      subject_id: '0',
      subject_type: 'Product',
      payload: JSON.stringify(payload),
    };

    const formData = new FormData();

    for (const name in body) {
      formData.append(name, body[name]);
    }

    return formData;
  }

  function _submitSatisfactionForm() {
    if (_satisfactionForm.elements.submit.disabled) {
      return;
    }

    const {rating: answer, comment, contact} = _getFormData();

    const payload = {
      ...app.config.loggingData.commonPayload,
      ...app.config.surveyData,
      answer,
      comment,
    };

    if (app.config.currentUser.primaryProvider === 'sid') {
      fetchData({
        url: `/api/v1/validation?phone=${contact}`,
        options: {method: 'GET'},
        isXMLHttp: true,
      }).then((res) => {
        if (res.valid) {
          payload['user_phone'] = contact;
        } else {
          payload['user_email'] = contact;
        }

        _sendConversionData(payload);
      });
    } else {
      _sendConversionData(payload);
    }

    _resetForm();
    _toggleFullForm();
    _setSubmitButtonState();
  }

  function _checkUserSigned() {
    if (!app.config.isUserSigned) {
      registerWithSID().then(() => {
        const config = app.config;
        config.loggingData.commonPayload['user_id'] = config.currentUser.id;
        _toggleFullForm();
      });
    } else {
      _toggleFullForm();
    }
  }

  function _addListener() {
    _fullFormShowButton.addEventListener('click', _checkUserSigned);
    _satisfactionForm.elements.comment.addEventListener(
      'input',
      _setSubmitButtonState
    );
    document.addEventListener('click', (evt) => {
      const target = evt.target;

      if (target.classList.contains('js-rating-value')) {
        _changeRatingButtonState(target);
      }

      if (target.classList.contains('js-satisfaction-submit-button')) {
        _submitSatisfactionForm();
      }
    });
  }

  function _init() {
    _addListener();
  }

  self.load = _satisfactionForm && _init;

  return self;
})(app.modules.satisfactionSurveyForm || {});
